<template>
  <div>
    <TimeRemain  :timeRemain="finishAt" @alertFinish="alertFinish" v-if="finishAt"/>

    <div class="flex justify-between items-center">
      <h1 class="text-lg font-bold" v-if="this.simulacrum">
        {{this.simulacrum.title}}
      </h1>

      <button
        class="mob-btn mob-btn--red"
        @click="showFinishModal()"
      >
        Finalizar
      </button>
      <MobBaseModal 
        ref="mobFinishSimulacrumModal"
        modal-id="modal-finish"
        title="Finalizar simulacro"
        body-text="Realmente deseas finalizar el simulacro?"
        :show-button1="true"
        :show-button2="true"
        button1-text="Aceptar"
        button2-text="Cancelar"
        :button1-callback="acceptFinishSimulacrumModal"
        :button2-callback="cancelFinishSimulacrumModal"
      />
    </div>     

    <div class="border rounded-lg mt-4">
      <MobSteps 
        class="border-b" 
        :items="simulacrumSteps" 
        :allowNavigation="true" 
        @goBack="goBack" 
        @goForward="goForward"
      />
      <div class="border-t p-7"  v-if="simulacrumExercise">
        <ExerciseItem
          ref="exerciseModule"
          :exercise="simulacrumExercise"
          :noCheck="true"
          :viewSolution="viewSolution"
          :originId="this.simulacrumId"
          :isReview="this.isReview"
          :origin="'simulacrumDiag'"
          :allowCorrection="allowCorrection"
          @nextQuestion="nextQuestion"
          :lastExercise="this.lastExercise"
          @goToResults="goToResults" />
      </div>
    </div>

  </div>
</template>

<script>
import { MobSteps } from "@/views/V2/components";
import mathJaxRender from "@/Utils/mathjax-render.js";
import ExerciseItem from "../components/ExerciseItem.vue";
import {enrollToSimulacrum, getExercises} from "@/services/simulacrum.service";
import {getQuestion} from "@/services/questions.service";
import {getSimulacrum} from "@/services/simulacrum.service";
import TimeRemain from "@/components/TimeRemain.vue";
import { MobBaseModal } from "@/views/V2/components";

export default {
  name: "SimulacrumDetail",
  props: {
    review: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    TimeRemain,
    MobSteps,
    ExerciseItem,
    MobBaseModal
  },
  data() {
    return {
      simulacrumExerciseId: null,
      simulacrumExercise: {},
      simulacrumSteps: [],
      simulacrum: {},
      allowCorrection: true,
      viewSolution: false,
      simulacrumId: null,
      exercises: [],
      lastExercise: false,
      finishAt: null,
      isReview: false,
      autoFinishTriggered: false,
    };
  },
  computed: {
    course() {
      return this.$store.state.course.current;
    },
  },
  methods: {
    goToResultsModal(){
      // /course/:id/diagnosticTest/:examId/results
      this.$refs.exerciseModule.finishQuestionnaire();
    },
    alertFinish() {
      if (this.review || this.autoFinishTriggered) return;
      this.autoFinishTriggered = true;
      this.$nextTick(() => {
        const ex = this.$refs.exerciseModule;
        if (ex) {
          ex.finishQuestionnaire();
        }
      });
    },
    goBack() {
      let indexQuestionActive =  this.exercises.findIndex(question => question.id === this.simulacrumExerciseId);

      if (indexQuestionActive === 0) {
        return;
      }
      this.nextQuestion(this.simulacrumExerciseId, false, true);
    },
    goToResults(){
      // /course/:id/diagnosticTest/:simulacrumId/results
      this.$router.push(`/course/${this.$route.params.id}/simulacrums/${this.simulacrumId}/results`);
    },
    showFinishModal() {
      this.$refs.mobFinishSimulacrumModal.showModal();
    },
    acceptFinishSimulacrumModal() {
      this.$refs.mobFinishSimulacrumModal.closeModal();
      this.goToResultsModal();
    },
    cancelFinishSimulacrumModal() {
      this.$refs.mobFinishSimulacrumModal.closeModal();
    },
    goForward() {
      let indexQuestionActive =  this.exercises.findIndex(question => question.id === this.simulacrumExerciseId);

      if (indexQuestionActive > this.exercises.length - 1) {
        return;
      }
      this.nextQuestion(this.simulacrumExerciseId, true, false);
    },
    async nextQuestion(questionId, plus = true, goback = false) {
      let sum = plus ? 1 : goback? -1 : 0;
      let indexQuestionActive =  this.exercises.findIndex(question => question.id === questionId) + sum;
      this.lastExercise = false;
      if (indexQuestionActive > this.exercises.length - 1) {
        return;
      }
      if (indexQuestionActive > this.exercises.length - 2) {
        this.lastExercise = true;
      }
      this.simulacrumSteps = [];
      for (let exercisesKey in this.exercises) {
        let exercise = this.exercises[exercisesKey];
        if (exercisesKey == indexQuestionActive) {
          this.simulacrumSteps.push({state: "active"})
          this.simulacrumExerciseId = exercise.id;
        } else {
          this.simulacrumSteps.push({state: "pending"})
        }
      }
      if (this.simulacrumExerciseId) {
        this.simulacrumExercise = await getQuestion(this.simulacrumExerciseId);
        mathJaxRender();
      }
    },
    async fillExercises() {

      let loader = this.$loading.show({});
      this.exercises = await getExercises(this.simulacrumId);
      if ( this.exercises.length > 0) {
        this.simulacrumSteps = [];
        await this.nextQuestion( this.exercises[0].id, false);

      }
      loader.hide();
    }
  },
  async mounted() {
    this.simulacrumId = this.$route.params.simulacrumId;

    if (this.review) {
      this.allowCorrection = false;
      this.viewSolution = true;
      this.isReview = true;
    }


    if (this.simulacrumId) {
      this.simulacrum = await getSimulacrum(this.simulacrumId);
      if (!this.review) {
        let simulacrumRegistry = await enrollToSimulacrum(this.$route.params.simulacrumId, this.$route.params.id);
        this.finishAt = simulacrumRegistry.finishAt;
      }
      await this.fillExercises();
    }
    mathJaxRender();
  },
  beforeMount() {
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();
  }
};
</script>
